import './App.css';
import { Routes, Route, Link } from 'react-router-dom';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
            text: 'Deadlift Progression',
        },
    },
};

const labels = ['Week 1', 'Week 2', 'Week 3'];

export const data = {
    labels,
    datasets: [
        {
            label: 'Dataset 1',
            data: [130,100,400],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        }
    ],
};

const Header = () => {
    return (
        <header className={'py-6 grid grid-cols-12 gap-6'}>
            <div className="col-span-3">
                <img src="https://dummyimage.com/400x200?text=LOGO" width={120} alt=""/>
            </div>

            <div className="col-span-9 text-end">
                <p>Welcome back, Johnie Forehead</p>
            </div>
        </header>
    )
}

const Footer = (props) => {
    return (
        <footer className={'fixed bottom-0 left-0 w-full p-4 flex flex-row-reverse justify-between bg-base-200 text-end'}>
            <Link to={props.next} className="btn btn-primary self-end">Next Exercise</Link>
            {props.prev && <Link to={'/workout-1'} className="btn btn-tertiary">Previous Exercise</Link> }
        </footer>
    )
}

const Login = () => {
  return (
      <div>
          <div className="container mt-16 mx-auto">
              <div className="grid grid-cols-12 gap-6">
                  <div className={'col-span-4 col-start-5'}>
                      <img src="https://dummyimage.com/400x100?text=LOGO" className={'mb-16 w-full'} alt=""/>
                  </div>

                  <div className="col-span-4 col-start-5">
                      <label className={'text-xs'}>Username</label>
                      <input type="text" className={'w-full mb-4 p-2'} />

                      <label className={'text-xs'}>PIN</label>
                      <input type="number" className={'w-full p-2 mb-4'} />

                      <Link to={'/overview'} className="btn btn-primary">Sign In</Link>
                  </div>
              </div>
          </div>
      </div>
  )
}

const Overview = () => {
    return (
        <div>
            <div className="container mx-auto">
                <Header />

                <div className="grid grid-cols-12 py-4 gap-6">
                    <div className="col-span-8">
                        <h1 className={'text-4xl font-bold'}>Strength Programme</h1>
                        <p className={'text-xl text-green-500'}><strong>Week:</strong> 2 / <strong>Workout</strong>: 1</p>

                        <h2 className="text-3xl mt-10 mb-2 font-bold">Description</h2>
                        <p className={'mb-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>
                        <p className={'mb-6'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>

                        <h3 className={'text-2xl'}>Key Factors</h3>
                        <ul className={'mt-4 list-disc pl-4'}>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                        </ul>
                    </div>

                    <div className="col-span-4">
                        <h2 className={'text-3xl font-bold'}>Equipment List</h2>

                        <ul className={'mt-4 list-disc pl-4'}>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                            <li>Barbell</li>
                        </ul>
                    </div>
                </div>
            </div>

            <footer className={'fixed bottom-0 left-0 w-full p-4 bg-base-200 text-end'}>
                <Link to={'/workout-1'} className="btn btn-primary">Time to Train</Link>
            </footer>
        </div>
    )
}

const Workout1 = () => {
    return (
        <div>
            <div className="container mx-auto">
                <Header />

                <div className="grid grid-cols-12 py-4 gap-6">
                    <div className="col-span-6">
                        <h1 className={'text-4xl text-green-500 font-bold'}>Deadlift</h1>

                        <h2 className="text-3xl mt-10 mb-2 font-bold">Notes on Deadlift</h2>
                        <p className={'mb-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>

                        <h2 className="text-3xl mt-10 mb-2 font-bold">Coach Notes</h2>
                        <p className={'mb-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>

                        <h2 className="text-3xl mt-10 mb-2 font-bold">My Notes</h2>
                        <p className={'mb-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>

                        <textarea rows="5" className={'p-4 w-full'} placeholder={"Enter your notes here..."}></textarea>
                        <button className="btn btn-secondary mt-4">Save Notes</button>
                    </div>

                    <div className="col-span-6">
                        <table className={'w-full '}>
                            <tr>
                                <td />
                                <th>Weight</th>
                                <th>Reps</th>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Warmup</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Warmup 2</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Set 1</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Set 2</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Set 3</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <Footer prev={false} next={'/workout-2'} />
        </div>
    )
}

const Workout2 = () => {
    return (
        <div>
            <div className="container mx-auto">
                <Header />

                <div className="grid grid-cols-12 py-4 gap-6">
                    <div className="col-span-6">
                        <h1 className={'text-4xl text-green-500 font-bold'}>Romanian Deadlifts</h1>

                        <h2 className="text-3xl mt-10 mb-2 font-bold">Notes on Romanian Deadlifts</h2>
                        <p className={'mb-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>

                        <h2 className="text-3xl mt-10 mb-2 font-bold">My Notes</h2>
                        <p className={'mb-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias asperiores dolores explicabo, in laborum, laudantium porro rem reprehenderit, sit tempora veniam? Accusamus animi dolores, facere necessitatibus velit voluptatibus!</p>

                        <textarea rows="5" className={'p-4 w-full'} placeholder={"Enter your notes here..."}></textarea>
                        <button className="btn btn-secondary mt-4">Save Notes</button>
                    </div>

                    <div className="col-span-6">
                        <table className={'w-full '}>
                            <tr>
                                <td />
                                <th>Weight</th>
                                <th>Reps</th>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Warmup</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Set 1</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Set 2</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <td className={'text-right p-4'}>Set 3</td>
                                <td className={'w-1/3'}>
                                    <input type="number" className={' p-2'} />
                                </td>
                                <td className={'w-1/3'}>
                                    <select className={'w-full p-2'}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <Footer prev={true} next={'/summary'} />
        </div>
    )
}

const Summary = () => {
    return (
        <div>
            <div className="container pb-[90px] mx-auto">
                <Header />

                <div className="grid grid-cols-12 py-4 gap-6">
                    <div className="col-span-10">
                        <h1 className={'text-4xl text-green-500 font-bold'}>Summary</h1>

                        <h2 className="text-2xl mt-10 mb-4 font-bold">Deadlift Progression</h2>
                        <Line options={options} data={data} />
                    </div>

                    <div className="col-span-2 flex items-center justify-end">
                        <button className={'btn btn-secondary'}>Next</button>
                    </div>

                    <div className="col-span-8">
                        <textarea rows="5" className={'p-4 mt-10 w-full'} placeholder={"Enter your notes here..."}></textarea>
                    </div>

                    <div className="col-span-4">
                        <h2 className="text-2xl mt-10 mb-4 font-bold">Next Workout</h2>
                        <p><strong>Duration:</strong> 1 hour</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab asperiores consequatur ea eveniet fugiat.</p>
                    </div>
                </div>
            </div>

            <footer className={'fixed bottom-0 left-0 w-full p-4 flex flex-row-reverse justify-between bg-base-200 text-end'}>
                <Link to={'/'} className="btn btn-primary self-end">Complete Session</Link>
            </footer>
        </div>
    )
}

const App = () => {
  return (
      <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/workout-1" element={<Workout1 />} />
          <Route path="/workout-2" element={<Workout2 />} />
          <Route path="/summary" element={<Summary />} />
        </Routes>
      </div>
  );
}

export default App;